import { render, staticRenderFns } from "./policyDiscount.vue?vue&type=template&id=461cd702&scoped=true&"
import script from "./policyDiscount.vue?vue&type=script&lang=js&"
export * from "./policyDiscount.vue?vue&type=script&lang=js&"
import style0 from "./policyDiscount.vue?vue&type=style&index=0&id=461cd702&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461cd702",
  null
  
)

export default component.exports